import type { Form } from "./form";
import type { ResourceWithId } from "./resource";

export interface InterruptionResource extends ResourceWithId {
    Title: string;
    Type: InterruptionType;
    Created: string;
    IsPending: boolean;
    Form: Form;
    RelatedDocumentIds: string[];
    ResponsibleTeamIds: string[];
    ResponsibleUserId: string;
    CanTakeResponsibility: boolean;
    HasResponsibility: boolean;
    TaskId: string;
    IsLinkedToOtherInterruption: boolean;
    CorrelationId: string;
}

export type InterruptionType = "ManualIntervention" | "GuidedFailure" | "PullRequestCompletion" | "ArgoCDApplicationSync";

export function AnyInterruptionRequiresUserInteraction(interruptionTypes: InterruptionType[]): boolean {
    return interruptionTypes.some((interruptionType) => interruptionType !== "ArgoCDApplicationSync");
}
